<template>
  <div class="mc" :id="'mc_' + parent.id">
    <template v-for="menu in menus" v-if="filterMenu(menu)">
      <div :key="menu.id+'a'" :id="'menu_' + menu.id" :class="getMenuClass(menu)" :style="style" @click="jump(menu)">
        <i :class="menu.icon || 'iconmenu el-icon-menu-default'"></i> {{menu.name}}
        <span></span>
      </div>
      <nav-menu-item :key="menu.id+'b'" :parent="menu" :menus="menus" @setMenu="jump"/>
    </template>
  </div>
</template>

<script>
  import * as config from '../../core/config'

  export default {
    name: 'NavMenuItem',
    props: {
      parent: {
        type: Object,
        required: false
      },
      menus: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        style: ''
      }
    },
    methods: {
      filterMenu (menu) {
        if (menu.pid === this.parent.id) {
          return true
        }
        return false
      },
      jump (menu) {
        this.$emit('setMenu', menu)
      },
      getMenuClass (menu) {
        let degree = (config.layout === 1) ? menu.degree : menu.degree + 1
        if (degree < 6) {
          return 'm' + degree
        }
        this.style = 'padding-left:' + (60 + (degree - 5) * 10) + 'px'
        return 'm'
      }
    }
  }
</script>
